<template>
  <div class="app-top-navigation" :class="[isFullScreen ? 'hide' : '']">
    <div class="top-navigation-bg"></div>
    <!-- 园区切换 -->
    <div class="top-navigation-container full-width full-height flex-between">
      <div class="flex-row valign-center left-area">
        <!-- <img class="app-logo" src="../../../common/assets/images/logoNew.png" /> -->
        <img class="" style="width: 90px; height: 35px; cursor: pointer;" src="../../../common/assets/images/logoOig.png"
          @click="backToHome" />
        <span style="margin: 0px 15px; display: inline-block; height: 22px;color:#fff"> | </span>
        <!--        <img class="" src="../../../common/assets/images/logoTitle.png" />-->
        <!--        <p class="app-name">{{ $t("system.platform.name") }}</p>-->
        <div class="app-name" @click="showSystem = !showSystem">
          <img src="../../../common/assets/images/system.png" />
          <div class="app-name-select">
            {{ parkName }}
          </div>
          <img style="cursor: pointer" :style="{
            transform: showSystem ? 'rotate(180deg)' : 'rotate(0deg)',
          }" src="../../../common/assets/images/select.png" />
        </div>
        <el-cascader-panel v-model="parkCode" :show-all-levels="false" :options="parkList" placeholder="请选择所属园区" :props="{
          expandTrigger: 'hover',
          checkStrictly: true,
          emitPath: false,
          label: 'parkName',
          value: 'parkId',
          children: 'childrens',
        }" @change="handleChoosePark" v-if="showSystem" class="app-name-select__listOpt" ref="parkPanel" />
        <!--        <div v-if="showSystem" class="app-name-select__list">-->
        <!--          <div-->
        <!--              v-for="item in systemList"-->
        <!--              :key="item.label"-->
        <!--              @click="changeSystem(item)"-->
        <!--              :class="[item.value == systemType ? 'selected' : '', 'app-name-select__item']"-->
        <!--          >-->
        <!--            {{ item.label }}-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="flex-row valign-center right-area">
        <!-- <div title="我的快捷入口"
             class="right-icon"
             @click="commonFun">
          <i class="el-icon-menu"></i>
        </div> -->
        <!-- 暂时屏蔽大屏页面入口 -->
        <!-- <div style="cursor: pointer" @click="pushMessage">推送消息</div> -->
        <div v-if="false" title="进入大屏" class="right-icon" @click="enterScreenPage">
          <i class="iconfont-lunan icon-lunan-huiyishiyuding"></i>
        </div>
        <!-- 暂时隐藏 -->
        <!-- <div class="right-icon"
             @click="viewAlarm">
          <i :class="[$config.fontFamily, 'ioc-Alarm1']"></i><span class="number-text">{{ alarmCount > 999 ? '999+' : alarmCount }}</span>
        </div> -->
        <!-- <div class="right-icon" @click="viewMessage">
          <i :class="[$config.fontFamily, 'ioc-Message']"></i><span class="number-text">{{ messageCount > 999 ? '999+' : messageCount }}</span>
        </div> -->
        <!-- <div class="right-time">
          <span class="time">{{ systemTime | moment }}</span>
          <span>{{ systemWeek }}</span>
        </div> -->
        <!-- 待办提醒 -->
        <el-dropdown placement="bottom" trigger="click" :key="key" class="right-icon user-warn">
          <div class="el-dropdown-link" @click="showTaskInfo">
            <el-badge :value="messageTotal" :max="99">
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>
          <el-dropdown-menu slot="dropdown">
            <div v-if="alarmList.length" style="width: 280px">
              <el-scrollbar>
                <div style="max-height: 250px">
                  <el-dropdown-item v-for="(item, index) in alarmList" :key="index" @click.native="goLink(item)">
                    <div class="taskIndex" :style="{
                      background: item.alarmLevel
                        ? alarmColorMap[item.alarmLevel + '']
                        : '#4B5566',
                    }">
                      {{ index + 1 }}
                    </div>
                    <div>
                      <div class="taskName" :title="alarmName(item)">
                        {{ alarmName(item) }}
                      </div>
                      <div style="padding-left: 5px; display: flex; justify-content: space-between;">
                        <!-- <span class="taskArea">
                          {{ item.area }}
                        </span> -->
                        <!-- <span class="taskTime">
                          {{ alarmTime(item) }}
                        </span> -->
                        <div>
                          <div class="taskLevel"
                            :style="{ background: item.alarmLevel ? alarmColorMap[item.alarmLevel + ''] : '#4B5566' }">
                            <div class="taskLevel-text">
                              {{ alarmLevelsRender(item.alarmLevel) }}
                            </div>
                          </div>
                        </div>
                        <div class="taskTime">
                          {{ alarmTime(item) }}
                        </div>
                      </div>
                    </div>
                  </el-dropdown-item>
                </div>
              </el-scrollbar>
              <div style="text-align: center; margin: 24px 0">
                <el-button type="primary" style="width: 55%" @click="clearTask">清除全部事件通知
                </el-button>
              </div>
            </div>
            <div v-else>
              <el-dropdown-item>
                <div style="color: black;">暂无数据</div>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 全屏展示 -->
        <div :title="$t('system.common.message.reqfullscreen')" class="right-icon fullScreen" @click="reqFullScreen">
          <i :class="[$config.fontFamily, 'ioc-Fullscreen']"></i>
        </div>
        <!-- 用户下拉框 -->
        <div id="topNavUserInfoButton" :class="['user-info valign-center', showUserPanel ? 'active' : '']"
          @click="showUserInfo">
          <span>{{ userInfo.nickName }}</span>
          <i :class="[$config.fontFamily, 'ioc-Drop_down']"></i>
        </div>
        <div class="user-avatar valign-center" @click="showViewer">
          <el-avatar size="medium" :src="avatarImg" fit="fill"></el-avatar>
          <span class="online-icon"></span>
        </div>
      </div>
    </div>

    <div id="topNavCenterPanel" :class="['center-panel', showCenterPanel ? 'show' : '']"
      :style="`left: ${centerPanelLeft}px;`">
      <el-scrollbar class="full-height no-scroll-x">
        <div v-for="(item, index) in centerList" :key="index" class="center-info">
          <div v-if="item.type === 1" key="topNavCenterItem">
            <p :class="[
              'center-item line-item valign-center',
              item.expand ? 'expand' : '',
            ]" @click="expandArea(index)">
              <i :class="[$config.fontFamily, 'ioc-Drop_down', 'arrow-icon']"></i><span>{{ item.name }}</span>
            </p>
            <ul :class="[item.expand ? 'expand' : 'collspand']" :style="`height: ${item.children.length * 32}px;`">
              <li v-for="(citem, cindex) in item.children" :key="cindex" :class="[
                'area-item line-item valign-center',
                currentCenterInfo.code === citem.code ? 'selected' : '',
              ]" @click="chooseArea(index, cindex)">
                <i :class="[$config.fontFamily, 'ioc-Stop', 'unhover']"></i><i
                  :class="[$config.fontFamily, 'ioc-Build', 'hover']"></i><span>{{ citem.name }}</span>
              </li>
            </ul>
          </div>
          <div v-else key="topNavCenterItem">
            <li :class="[
              'area-item line-item valign-center',
              currentCenterInfo.code === item.code ? 'selected' : '',
            ]" @click="chooseArea(index)">
              <i :class="[$config.fontFamily, 'ioc-Stop', 'unhover']"></i><i
                :class="[$config.fontFamily, 'ioc-Build', 'hover']"></i><span>{{ item.name }}</span>
            </li>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div id="topNavUserPanel" class="hover-blur-panel" :class="['user-panel', showUserPanel ? 'show' : '']">
      <div class="user-panel-line profile-line flex-row" @click="viewProfile">
        <div class="user-panel-title valign-center" style="height: 55px">
          <i :class="[$config.fontFamily, 'ioc-Stop']" style="margin-right: 6px"></i>
          <div>
            <div style="margin-bottom: 6px">{{ $t("home.label.profile") }}</div>
            <div style="font-size: 12px">点击进入，修改个人信息、密码</div>
          </div>
        </div>
      </div>
      <!-- 主题切换 -->
      <!-- <div class="user-panel-line">
        <p class="user-panel-title valign-center">
          <i :class="[$config.fontFamily, 'ioc-Stop']"></i
          ><span>{{ $t("home.label.theme") }}</span>
        </p>
        <div class="panel-list">
          <el-scrollbar class="full-height no-scroll-x">
            <div
              v-for="(item, index) in themes"
              :key="index"
              :title="item.name"
              :class="[
                'theme-item',
                item.value === currentTheme ? 'active' : '',
              ]"
              @click="changeTheme(item.value)"
            >
              <p
                class="theme-inner"
                :style="`background-color: ${item.mainColor};`"
              ></p>
            </div>
          </el-scrollbar>
        </div>
      </div> -->
      <!-- 语言切换 -->
      <div class="user-panel-line" v-if="false">
        <p class="user-panel-title valign-center">
          <i :class="[$config.fontFamily, 'ioc-Stop']"></i><span>{{ $t("home.label.language") }}</span>
        </p>
        <div class="panel-list">
          <el-scrollbar class="full-height no-scroll-x">
            <div v-for="(item, index) in languages" :key="index" :class="[
              'lang-item valign-center text-ellipse',
              item.value === currentLanguage ? 'active' : '',
            ]" @click="changeLanguage(item.value)">
              <i :class="[$config.fontFamily, 'ioc-Stop']"></i><span>{{ item.name }}</span>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <!-- 地图切换 -->
      <div class="user-panel-line" v-if="false">
        <p class="user-panel-title valign-center">
          <i :class="[$config.fontFamily, 'ioc-Stop']"></i><span>地图切换</span>
        </p>
        <div class="panel-list">
          <el-scrollbar class="full-height no-scroll-x">
            <div :class="[
              'lang-item valign-center text-ellipse',
              mapType === '2d' ? 'active' : '',
            ]" @click="changeMapType('2d')">
              <i :class="[$config.fontFamily, 'ioc-Stop']"></i><span>2D</span>
            </div>
            <div :class="[
              'lang-item valign-center text-ellipse',
              mapType === '3d' ? 'active' : '',
            ]" @click="changeMapType('3d')">
              <i :class="[$config.fontFamily, 'ioc-Stop']"></i><span>3D</span>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="logout-line flex-center">
        <el-button type="primary" @click="logout">{{ $t("home.button.logout") }}
        </el-button>
      </div>
    </div>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <commonFun ref="commonFun"></commonFun>
  </div>
</template>
<script>
import themeConfig from "@src/common/config/theme";
import commonFun from "./commonFun";
import sysInit from "@src/init";
// 工具库-Cache缓存操作工具库
import utils, { Cache, Dates } from "$utils";
import { mapMutations } from "vuex";
import eventBus from "@src/common/utils/eventBus";
import eventConfig from "@src/common/config/eventConfig";
import cacheKeys from "@/common/config/cacheKeys";

export default {
  components: { commonFun },
  props: {},
  data() {
    return {
      parkName: "",
      parkCode: "",
      parkList: [],
      key: 1,
      messageTotal: 100,
      showSystem: false,
      systemType: "0",
      systemList: [
        { label: "鲁南制药集团园区", value: "0" },
        { label: "新时代药业园区", value: "1" },
      ],
      taskList: [
        {
          label: "火警报警（感烟探测器）",
          value: "0",
          area: "芝兰路18号1号楼西侧",
          time: "2022-08-08 18:22:22",
          url: "",
        },
        {
          label: "人员黑名单",
          value: "0",
          area: "芝兰路18号1号楼西侧",
          time: "2022-08-08 18:22:22",
          url: "",
        },
        {
          label: "重点区域入侵检测",
          value: "0",
          area: "芝兰路18号1号楼西侧",
          time: "2022-08-08 18:22:22",
          url: "",
        },
        {
          label: "周界入侵报警",
          value: "0",
          area: "芝兰路18号1号楼西侧",
          time: "2022-08-08 18:22:22",
          url: "",
        },
        {
          label: "陌生人识别提示",
          value: "0",
          area: "芝兰路18号1号楼西侧",
          time: "2022-08-08 18:22:22",
          url: "",
        },
      ],
      taskColor: ["#A8131C", "#A9501C", "#A9AC1C", "#10ACB5", "#4BAC1C"],
      alarmColorMap: {
        1: "#ff4547",
        2: "#ff466e",
        3: "#ffbf00",
        4: "#2a65ff",
      },
      viewerInstance: null,
      viewerPhotos: [],
      avatarImg: "",
      themes: [],
      languages: this.$i18n.LANGUAGES,
      showCenterPanel: false,
      showUserPanel: false,
      centerPanelLeft: 184,
      messageCount: 0,
      centerList: [],
      systemTime: "",
      systemWeek: "",
      time: "",
    };
  },
  watch: {
    userInfo(nv, ov) {
      /* if (nv.fileCode) {
        this.avatarImg = Bus.imgPath(nv.fileCode)
      } else {
        if (nv.sex === 0) {
          this.avatarImg = `./images/theme/${this.currentTheme}/photo-women.png`
        } else {
          this.avatarImg = `./images/theme/${this.currentTheme}/photo.png`
        }
      } */
      this.parkName = nv.parkName;
      this.parkCode = nv.parkId;
      this.parkList = nv.parkInfoTree;
      this.avatarImg = nv.avatarImg;
      this.viewerPhotos = [this.avatarImg];
    },
    alarmList: {
      handler(newVal) {
        // console.log(newVal);
        this.messageTotal = newVal.length;
      },
      immediate: true,
    },
  },
  computed: {
    alarmCount() {
      return this.$store.getters.alarmCount || 0;
    },
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
    currentLanguage() {
      return this.$store.getters.currentLanguage;
    },
    currentCenterInfo() {
      return this.$store.getters.currentCenterInfo || {};
    },
    userInfo() {
      return this.$store.getters.userInfo || {};
    },
    isFullScreen() {
      return this.$store.getters.isFullScreen;
    },
    mapType() {
      return this.$store.getters.mapType;
    },
    alarmList() {
      return this.$store.getters.getAlarmList || [];
    },
  },
  created() {
    // this.getTime();
    // 封装主题列表信息
    for (let key in themeConfig.THEME_MAP) {
      this.themes.push({
        value: key,
        mainColor: themeConfig.THEME_MAP[key].mainColor,
        name: this.$t(themeConfig.THEME_MAP[key].themeName),
      });
    }
  },
  beforeDestroy() {
    // clearInterval(this.time);
    document.removeEventListener("click", this.hidePanel);
  },
  mounted() {
    sysInit.getUserLoginInfo.apply(this);
  },
  methods: {
    backToHome() {
      let allMenuList = JSON.parse(sessionStorage.getItem("MENUALL"))
      let firstPage = allMenuList.menuList[0].childrens[0].childrens[0];
      this.$router.push(firstPage.path);
      this.addMenuFromLeftNav(firstPage)
    },
    addMenuFromLeftNav(tabMenu) {
      let menu = {
        activePath: tabMenu.path,
        code: tabMenu.menuCode,
        name: tabMenu.menuName,
        path: tabMenu.path,
        subsystemId: tabMenu.subsystemId,
        subsystemName: tabMenu.subsystemName
      }
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    },
    alarmLevelsRender(value) {
      if (value == 1) {
        return '紧急'
      } else if (value == 2) {
        return '严重'
      } else if (value == 3) {
        return '一般'
      } else if (value == 4) {
        return '普通'
      } else {
        return ''
      }
    },
    ...mapMutations({
      addToAlarmList: "ADD_ALARM_TO_LIST",
      removeFromAlarmList: "REMOVE_ALARM_FROM_LIST",
    }),
    handleChoosePark(val) {
      const account = Cache.get("CACHE_USER_INFO");
      this.parkName = this.$refs.parkPanel.getCheckedNodes()[0].label;
      account.parkName = this.parkName;
      account.parkId = val;
      Cache.put("CACHE_USER_INFO", account);
      this.$app.AppInstance.refresh();
      this.showSystem = false;
    },
    pushMessage() {
      // this[key].deviceName = message.alarmName; //告警名称
      // this[key].alarmId = message.alarmId;
      // this[key].subSystem = message.subSystem;
      // this[key].alarmType = message.alarmType;
      // this[key].commonAlarmType = message.commonAlarmType;
      // this[key].alarmTime = message.alarmTime; //告警时间
      // this[key].alarmLevel = message.alarmLevel; //告警级别
      const mockMsg = {
        alarmName: "火警报警（感烟探测器）",
        label: "火警报警（感烟探测器）",
        value: "0",
        area: "芝兰路18号1号楼西侧",
        time: "2023-02-08 18:22:22",
        url: "",
        alarmLevel: parseInt(Math.random() * 10 + 1) % 5,
      };
      console.log(this.$store);
      console.log(this.alarmList);
      // this.addToAlarmList(mockMsg)
      // this.$store.commit('ADD_ALARM_TO_LIST', mockMsg)
    },
    goLink(item) {
      console.log(item);
      let key = item.key;
      let route = {};
      if (key == "FIREFIGHTINGALARM") {
        route = {
          name: "消防告警",
          path: "/fireAlarm",
        };
      } else if (key == "FIREPATROLITEM_EXCEPTION_MESSAGE") {
        route = {
          name: "防火巡查统计",
          path: "/firePatrol/count",
        };
      } else {
        route = {
          name: "实时告警",
          path: "/realTimeAlarm",
        };
      }
      this.$router.push({ path: route.path });
      eventBus.emit(eventConfig.MENU_CLICK, route);
    },
    // 清空全部任务
    clearTask() {
      this.messageTotal = 0;
      this.taskList = [];
      this.key += 1;

      this.removeFromAlarmList();
    },
    showTaskInfo() { },
    changeSystem(item) {
      this.systemType = item.value;
      this.showSystem = false;
    },
    getTime() {
      this.$fetch("/time/time/").then((res) => {
        let data = res.slice(0, -1);
        let resTime = data.split(",")[1].split(":")[1] * 1000;
        this.systemTime = resTime;
        this.systemWeek =
          "星期" + "日一二三四五六".charAt(new Date(this.systemTime).getDay());
        var timeDiff = new Date().valueOf() - resTime; //算出时间差
        this.time = setInterval(() => {
          this.systemTime = new Date().valueOf() - timeDiff;
          this.systemWeek =
            "星期" + "日一二三四五六".charAt(new Date(this.systemTime).getDay());
        }, 1000);
      });
    },
    changeMapType(mapType) {
      this.$store.commit("SET_MAP_TYPE", mapType);
    },
    showViewer() {
      this.viewerInstance.show();
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    getCenterInfo(centerCode, centerList) {
      let centerInfo = null;
      if (centerList && centerList.length) {
        centerList.forEach((item) => {
          if (item.type === 2 && item.code === centerCode) {
            centerInfo = item;
          }
        });
      }
      return centerInfo;
    },
    /**
     * [hidePanel 根据当前点击的位置，判断当前点击的是否是面板区域，如果点击的不是弹出的面板区域，则隐藏面板和遮罩层]
     * @param  {[Object]} event [点击的事件对象，从中获取当前点击的元素]
     * @return {[Null]} [无]
     */
    hidePanel(event) {
      let el = event.target;
      while (el && el.tagName !== "BODY") {
        let elId = el.getAttribute("id");
        if (elId && this.panelControlId && this.panelControlId.indexOf(elId) !== -1) {
          return;
        }
        el = el.parentNode;
      }
      // 如果当前未点击在弹出的面板上，则隐藏所有面板
      this.showCenterPanel = false;
      this.showUserPanel = false;
      this.$app.AppInstance.hideCover();
      document.removeEventListener("click", this.hidePanel);
    },
    /**
     * [changeLanguage 更改语种]
     * @param  {[String]} val [更改后的语种值]
     * @return {[Null]} [无]
     */
    changeLanguage(val) {
      this.$store.dispatch("setCurrentLanguage", val);
    },
    /**
     * [changeTheme 更改主题]
     * @param  {[String]} val [更改后的主题值]
     * @return {[Null]} [无]
     */
    changeTheme(val) {
      this.$store.dispatch("setCurrentTheme", val);
    },
    /**
     * [viewAlarm 点击告警图标，进入告警页面]
     * @return {[Null]} [无]
     */
    viewAlarm() {
      this.$router.push({ path: "/realTimeAlarm" });
      this.$log.info("用户点击查看告警信息，需跳转至实时告警页面");
    },
    /**
     * [viewMessage 点击消息图表，进入消息面板页面]
     * @return {[Null]} [无]
     */
    viewMessage() {
      this.$log.info("用户点击查看纬度信息，需跳转至消息面板页面");
    },
    /**
     * [viewProfile 点击用户信息面板上的“个人中心”，进入个人中心页面]
     * @return {[Null]} [无]
     */
    viewProfile() {
      this.$log.info("用户点击个人中心，需跳转至个人中心页面");
      this.$router.push({ path: "/usercenter" });
      // 移除document点击事件并且隐藏面板和遮罩层
      document.removeEventListener("click", this.hidePanel);
      this.showUserPanel = false;
      this.$app.AppInstance.hideCover();
    },
    /**
     * [viewProfile 点击常用功能，进行常用功能设置]
     * @return {[Null]} [无]
     */
    commonFun() {
      this.$refs.commonFun.drawer = true;
    },

    /**
     * [reqFullScreen 进入全屏方法]
     * @return {[Null]} [无]
     */
    reqFullScreen() {
      this.$log.info("用户点击进入全屏");
      this.$utils.reqFullScreen();
    },
    enterScreenPage() {
      this.$log.info("用户点击进入大屏页面，跳转至大屏页面，同时将页面全屏");
      this.$router.push({
        path: "/screen/index",
      });
      this.$utils.reqFullScreen();
    },
    /**
     * [showCenterInfo 展示中心区域列表面板]
     * @return {[Null]} [无]
     */
    showCenterInfo() {
      // 获取当前按钮的位置，用于调整弹框的位置
      this.centerPanelLeft = document.getElementById("topNavCenterAreaButton").offsetLeft;
      // 点击当前中心按钮时，展示/隐藏中心区域列表面板，该面板的展示由showCenterPanel控制
      this.showCenterPanel = !this.showCenterPanel;
      // 隐藏用户信息面板
      this.showUserPanel = false;
      if (this.showCenterPanel) {
        // 如果面板为展示状态，则注册document点击事件，用户点击其他区域关闭展示的面板及遮罩层
        this.panelControlId = ["topNavCenterAreaButton", "topNavCenterPanel"];
        document.addEventListener("click", this.hidePanel);
        this.$app.AppInstance.showCover();
      } else {
        // 面板隐藏后，移除document点击事件，避免用户在其他业务中点击其他位置关闭了弹框及遮罩层
        document.removeEventListener("click", this.hidePanel);
        this.$app.AppInstance.hideCover();
      }
    },
    /**
     * [showCenterInfo 展示用户信息面板]
     * @return {[Null]} [无]
     */
    showUserInfo() {
      this.showUserPanel = !this.showUserPanel;
      this.showCenterPanel = false;
      if (this.showUserPanel) {
        this.panelControlId = ["topNavUserInfoButton", "topNavUserPanel"];
        document.addEventListener("click", this.hidePanel);
        this.$app.AppInstance.showCover();
      } else {
        document.removeEventListener("click", this.hidePanel);
        this.$app.AppInstance.hideCover();
      }
    },
    /**
     * [expandArea 点击某个中心区域时，展开/收缩当前中心下的所有子区域列表]
     * @param  {[Number]} index [中心列表的索引，用于获取当前中心信息]
     * @return {[Null]} [无]
     */
    expandArea(index) {
      this.centerList[index].expand = !this.centerList[index].expand;
    },
    /**
     * [chooseArea 点击并选中（切换）某个区域时]
     * @param  {[Number]} index  [中心列表的索引，如果无多级多域，只有区域列表时，则该值为区域列表的索引值]
     * @param  {[Number]} cindex [存在多级多域时，该值为当前中心下的区域列表索引]
     * @return {[Null]} [无]
     */
    chooseArea(index, cindex) {
      let centerInfo = this.centerList[index];
      if (centerInfo && centerInfo.children && centerInfo.children.length) {
        centerInfo = centerInfo.children[cindex];
      }
      if (centerInfo.code !== this.currentCenterInfo.code) {
        // 设置当前区域并且触发内容区域刷新，内容区域展示的数据很多是根据区域进行获取的，需要触发其根据新的区域重新获取数据
        this.$store.dispatch("setControlInfo", centerInfo);
        this.$app.AppInstance.refresh();
      }
      document.removeEventListener("click", this.hidePanel);
      // 隐藏中心区域面板并隐藏遮罩层
      this.showCenterPanel = false;
      this.$app.AppInstance.hideCover();
    },
    /**
     * [logout 用户退出登录，退出登录后，清除所有用户相关信息，然后进入用户登录页面]
     * @return {[Null]} [无]
     */
    logout() {
      this.showUserPanel = false;
      this.$app.AppInstance.hideCover();
      this.$confirm(this.$t("base.message.confirmOut"), this.$t("base.title.confirm"), {
        confirmButtonText: this.$t("base.button.confirm"),
        cancelButtonText: this.$t("base.button.cancel"),
        type: "warning",
        cancelButtonClass: "cancel-button-css",
      }).then(() => {
        const { access_token } = Cache.get("CACHE_USER_INFO");
        let param = "token=" + `${access_token}`;
        // console.log(param)
        this.$fetch(this.$api.common.userLogout, param).then((response) => {
          if (response.success) {
            this.$router.push({ path: this.$config.LOGIN_PAGE });
            this.$store.dispatch("clearUserCache");
            this.$log.info("用户退出登录成功");
            this.$store.commit(cacheKeys.MENU_TABS_LIST, []);
          } else {
            this.$message({
              type: "error",
              message: response.msgContent,
            });
            this.$log.warn("用户退出登录失败");
          }
        });
      });
    },
    alarmName(item) {
      if (item.key == "FIREPATROLITEM_EXCEPTION_MESSAGE") {
        return `【巡检项异常】${item.deviceName}`;
      }
      if (!item.subSystemLabel) return item.alarmName;
      return `【${item.subSystemLabel}】${item.alarmName}`;
    },
    alarmTime(item) {
      if (item) {
        return Dates.format(item.alarmTime, "yyyy-MM-dd HH:mm:ss");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.el-popper {
  border: none;
  border-radius: 0px 0px 5px 5px;
  @include set_theme_color(background-color, popper-bg-color);

  .el-dropdown-menu__item {
    // color: #e8eaee;
    color: #303133;
    // border-bottom: 1px solid #414653;
    padding: 5px 16px;
    display: flex;
    font-size: 12px;

    align-items: center;

    &:hover {
      // color: #e8eaee;
      color: #303133;
      // @include set_theme_color(background-color, button-content-bg-color);
      background-color: #D7E8FF;
    }

    .taskIndex {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      line-height: 32px;
      font-size: 14px;
      text-align: center;
      margin-right: 12px;
      color: #ffffff;
    }

    .taskName {
      font-size: 14px;
      width: 200px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #303133;
    }

    .taskArea {
      color: #9aa6c1;
      margin-right: 10px;
    }

    .taskLevel {
      width: 42px;
      height: 20px;
      line-height: 20px;
      border-radius: 7px;
      margin-left: 2px;
    }

    .taskLevel-text {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 12px;
    }

    .taskTime {
      // color: #9aa6c1;
      color: #606266;
    }
  }
}

.app-top-navigation {
  height: 50px;
  width: 100%;
  padding: 0 10px;
  position: relative;
  @include set_animation(all);

  .top-navigation-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    // @include set_theme_color(background-color, top-menu-bg-color);
    background-color: rgba(0, 36, 64, 1);
    // backdrop-filter: blur(2px);
  }

  .top-navigation-container {
    position: relative;
  }

  &.hide {
    height: 0;
    overflow: hidden;
  }

  .left-area {
    height: 100%;

    .app-logo {
      height: 40px;
    }

    .app-name {
      font-weight: bold;
      // margin-left: 15px;
      line-height: 32px;
      font-size: 15px;
      // width: 200px;
      height: 32px;
      background: #fff;
      border-radius: 50px 50px 50px 50px;
      padding: 0px 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      //margin-left: 16px;
      @include set_theme_color(color, font-active-color);
    }

    .app-name-select {
      cursor: pointer;
      width: 130px;
      font-size: 14px;
      font-weight: 400;
      // color: #ffffff;
      margin: 0 10px;
    }

    .app-name-select__listOpt {
      position: absolute;
      left: 105px;
      top: 47px;
      z-index: 999;
      border-color: #3e76e6 !important;
    }

    .app-name-select__list {
      position: absolute;
      left: 105px;
      top: 47px;
      z-index: 2;
      background: rgb(32, 40, 66);
      height: 100px;
      border-radius: 10px;
      width: 200px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .app-name-select__item {
      cursor: pointer;
      padding: 6px;
      border-radius: 3px;
      font-size: 14px;

      &.selected {
        background: #2b53a1;
      }

      &:hover {
        background: #2b53a1;
      }
    }

    .split-line {
      width: 1px;
      height: 15px;
      @include set_theme_color(background-color, font-active-color);
      margin: 0 8px;
    }

    .center-area {
      height: 30px;
      border-radius: 15px;
      padding: 0 15px;
      cursor: pointer;
      @include set_theme_color(background-color, page-tab-item-bg-color);
      @include set_theme_color(color, font-active-color);

      &.active,
      &:hover {
        @include set_theme_color(background-color, page-tab-item-active-color);
      }

      .center-icon {
        @include set_theme_color(color, main-theme-color);
      }

      .center-name {
        margin: 0 10px;
      }

      .arrow-icon {
        font-size: 12px;
        @include set_animation(all);
      }

      &.active {
        .arrow-icon {
          transform: rotate(-180deg);
        }
      }
    }
  }

  .right-area {
    .right-icon {
      margin: 0 15px;
      position: relative;
      cursor: pointer;

      i {
        color: #fff;
        font-size: 18px;
      }

      &:hover {
        i {
          @include set_theme_color(color, font-active-color);
        }
      }

      .number-text {
        position: absolute;
        top: -8px;
        left: 10px;
        font-size: 12px;
        height: 15px;
        border-radius: 8px;
        @include set_theme_color(color, font-active-color);
        padding: 0 4px;
        background-color: #ee1818;
      }
    }

    .right-time {
      margin-right: 30px;

      .time {
        margin-right: 10px;
      }
    }

    .user-info {
      margin-right: 5px;
      cursor: pointer;
      padding: 13px 8px;
      border-radius: 5px;
      height: 24px;
      position: relative;
      color: #fff;

      &.active,
      &:hover {
        @include set_theme_color(color, font-active-color);
        @include set_theme_color(background-color, page-tab-item-active-color);
      }

      i {
        margin-left: 10px;
        font-size: 12px;
        @include set_animation(all);
      }

      &.active {
        i {
          transform: rotate(-180deg);
        }
      }
    }

    .fullScreen {
      padding: 5px 8px;
      border-radius: 5px;

      &:hover {
        @include set_theme_color(background-color, page-tab-item-active-color);
      }
    }

    .user-warn {
      padding: 5px 6px;
      border-radius: 5px;

      i {
        color: #fff;
      }

      &:hover {
        @include set_theme_color(background-color, page-tab-item-active-color);
        @include set_theme_color(color, main-theme-color);
      }
    }

    :deep .el-avatar {
      img {
        height: 100% !important;
        width: 100% !important;
      }
    }

    .user-avatar {
      position: relative;

      img {
        height: 100% !important;
        width: 100% !important;
      }

      .online-icon {
        position: absolute;
        right: -2px;
        bottom: -2px;
        height: 10px;
        width: 10px;
        border: 1px solid;
        border-radius: 10px;
        @include set_theme_color(background-color, main-theme-color);
        @include set_theme_color(border-color, font-active-color);
      }
    }
  }

  .center-panel {
    position: absolute;
    left: 184px;
    top: 50px;
    width: 165px;
    z-index: 10;
    @include set_theme_color(background-color, left-menu-bg-color);
    height: 0;
    display: block;
    @include set_animation(all);
    overflow: hidden;

    &.show {
      height: 200px;
    }

    .center-info {
      .line-item {
        height: 32px;
        cursor: pointer;

        &:hover {
          @include set_theme_color(background-color, item-active-bg-color);
        }

        i {
          font-size: 12px;
        }

        span {
          margin-left: 5px;
        }
      }

      .center-item {
        padding: 0 10px;
        @include set_theme_color(color, font-active-color);

        i {
          @include set_animation(all);
        }

        &.expand {
          i {
            transform: rotate(-180deg);
          }
        }
      }

      .area-item {
        padding: 0 15px;

        .unhover {
          font-size: 16px;
          display: block;
        }

        .hover {
          font-size: 16px;
          display: none;
          @include set_theme_color(color, main-theme-color);
        }

        &:hover {
          @include set_theme_color(color, font-active-color);

          .unhover {
            display: none;
          }

          .hover {
            display: block;
          }
        }

        &.selected {
          @include set_theme_color(color, main-theme-color);
        }
      }

      ul {
        height: 100%;
        overflow: hidden;
        @include set_animation(all);

        &.collspand {
          height: 0px !important;
        }
      }
    }
  }

  .user-panel {
    position: absolute;
    right: 40px;
    top: 50px;
    width: 265px;
    z-index: 99;
    height: 0;
    display: block;
    @include set_animation(all);
    overflow: hidden;
    @include set_theme_color(color, left-menu-font-color);
    // @include set_theme_color(background-color, popper-bg-color);
    // @include set_theme_color(background-color, map-panel);

    &.show {
      // @include set_theme_color(background-color, page-tab-item-active-color);
      // box-shadow: 0px 5px 10px 5px #40526d;
      // border: 1px solid;
      height: 130px; // 190px;;
    }

    .user-panel-line {
      padding: 0 16px;

      &.profile-line {
        margin: 15px 0px;
        cursor: pointer;

        &:hover {
          @include set_theme_color(color, main-theme-color);
          // @include set_theme_color(background-color, button-content-bg-color);
        }
      }

      .user-panel-title {
        height: 32px;

        span {
          margin-left: 10px;
        }
      }

      .panel-list {
        padding: 5px 15px;
        height: 85px;

        .theme-item {
          float: left;
          height: 30px;
          width: 30px;
          margin: 0 30px 10px 0;
          cursor: pointer;
          padding: 1px;

          &.active {
            border: 1px solid;
            @include set_theme_color(border-color, active-border-color);
          }

          .theme-inner {
            width: 100%;
            height: 100%;
          }
        }

        .lang-item {
          float: left;
          cursor: pointer;
          margin: 0 5px 5px 0;
          height: 24px;
          width: calc((100% - 10px) / 2);

          &.active {
            @include set_theme_color(color, main-theme-color);
          }

          span {
            margin-left: 5px;
          }
        }
      }

      .logout-line {
        margin-top: 8px;
      }
    }
  }
}
</style>
